module.exports = __webpack_public_path__ + "media/assets/dashboard/mail-28b4b11e09d112228f82b7ca5fc95d8d.png";